import './App.css';
import { Container } from './components/container/container';
import { TopUpContainer } from './components/topUpContainer/container';
import { Initpay } from './components/initpay/initpay';
import Demo from './pages/demo/index';
import {PaymentLink} from './pages/payment/paymentLink';
import { PaymentSuccess } from './pages/paymentSuccess/PaymentSuccess';
import { PAYMENT_SUCCESS_PATH } from './utils/paymentSuccessLock';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import TransactionAuth from './utils/transactionAuth';
import { Toaster } from 'react-hot-toast';

function App() {
	return (
		<div className="App">
			<Toaster
				position="top-right"
				toastOptions={{
					duration: 3000,
				}}
			/>
			<Router>
				<Routes>
					<Route path="/" element={<Container />} />
					<Route path="/top-up" element={<TopUpContainer />} />
					<Route path="/start" element={<Initpay />} />
					<Route path="/demo" element={<Demo />} />
					<Route path="/payment-link" element={<PaymentLink />} />
					<Route path={PAYMENT_SUCCESS_PATH} element={<PaymentSuccess />} />
					<Route path="/status" element={<TransactionAuth />} />
					<Route path="/*" element={<Navigate to="/demo" />} />
				</Routes>
			</Router>
		</div>
	);
}

export default App;
